import { Injectable } from '@angular/core';
import {
  PassengerService as PassengerApiService,
} from '../../../../api/gen/api/api/passenger.service';
import {
  PassengerUserAccountService as PassengerUserAccountApiService,
} from '../../../../api/gen/api/api/passengerUserAccount.service';
import {
  CreatePassengerDto,
  UpdatePassengerDto,
  CreatePassengerUserAccountDto,
  UpdatePassengerUserAccountDto,
  GetPassengerStatisticsFilterRequest,
} from '../../../../api/gen/api';

@Injectable({
  providedIn: 'root',
})
export class PassengerService {
  constructor(
    private apiService: PassengerApiService,
    private passengerUserAccountApiService: PassengerUserAccountApiService,
  ) {}

  addPassenger(passenger: CreatePassengerDto) {
    return this.apiService.managementPassengersPost(passenger);
  }

  getPassengerById(id: string) {
    return this.apiService.managementPassengersPassengerIdGet(id);
  }

  updatePassenger(passengerId: string, passenger: UpdatePassengerDto) {
    return this.apiService.managementPassengersPassengerIdPut(passengerId, passenger);
  }

  getPassengersOfTaxiCenter(taxiCenterId: string) {
    return this.apiService.managementPassengersTaxiCentersTaxiCenterIdGet(taxiCenterId);
  }

  getAllPassengers() {
    return this.apiService.managementPassengersGet();
  }

  addPassengerUserAccount(request: CreatePassengerUserAccountDto) {
    return this.passengerUserAccountApiService.managementPassengerUserAccountsPost(request);
  }

  updatePassengerUserAccount(request: UpdatePassengerUserAccountDto) {
    return this.passengerUserAccountApiService.managementPassengerUserAccountsPut(request);
  }

  getPassengerUserAccountsOfTaxiCenter(taxiCenterId: string) {
    return this.passengerUserAccountApiService.managementPassengerUserAccountsTaxiCentersTaxiCenterIdGet(taxiCenterId);
  }

  getPassengerUserAccounts() {
    return this.passengerUserAccountApiService.managementPassengerUserAccountsGet();
  }

  getPassengerUserAccountById(id: string) {
    return this.passengerUserAccountApiService.managementPassengerUserAccountsPassengerUserAccountIdGet(id);
  }

  sendPassengerUserAccountInvitation(passengerUserAccountId: string) {
    return this.passengerUserAccountApiService.managementPassengerUserAccountsPassengerUserAccountIdInvitePost(passengerUserAccountId);
  }

  deletePassenger(passengerId: string) {
    return this.apiService.managementPassengersPassengerIdDelete(passengerId);
  }

  deletePassengerUserAccount(passengerUserAccountId: string) {
    return this.passengerUserAccountApiService.managementPassengerUserAccountsPassengerUserAccountIdDelete(passengerUserAccountId);
  }

  getPassengerStatistics(req: GetPassengerStatisticsFilterRequest) {
    return this.apiService.managementPassengersStatisticsPost(req);
  }
}
